var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.registries.length > 0)?_c('details-grid',{attrs:{"title":_vm.title,"header":_vm.header,"rows":_vm.rows}}):_c('div',{staticClass:"d-none",attrs:{"data-title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }